// Modelo de datos para EstadoSucursal
export class EstadoSucursal {
  constructor(data = {}) {
    console.log('🔍 EstadoSucursal constructor - data recibido:', data);
    console.log('🔍 EstadoSucursal constructor - keys disponibles:', Object.keys(data));
    
    // ✅ Verificar si data ya es una instancia de EstadoSucursal
    if (data instanceof EstadoSucursal) {
      this.Id_estado = data.Id_estado;
      this.Id_sucursal = data.Id_sucursal;
      this.Estado = data.Estado;
      this.Observa = data.Observa;
      this.Fecha = data.Fecha;
      this.Hora = data.Hora;
      this.Nombre_sucursal = data.Nombre_sucursal;
    } else {
      // ✅ Mapeo desde datos de API (soporta minúsculas y mayúsculas)
      this.Id_estado = data.id_estado ?? data.Id_estado ?? 0;
      this.Id_sucursal = data.id_sucursal ?? data.Id_sucursal ?? 0;
      this.Estado = data.estado ?? data.Estado ?? 'OFFLINE';
      this.Observa = data.observa ?? data.Observa ?? '';
      this.Fecha = data.fecha ?? data.Fecha ?? '';
      this.Hora = data.hora ?? data.Hora ?? '';
      this.Nombre_sucursal = data.nombre_sucursal ?? data.Nombre_sucursal ?? '';
    }
    
    console.log('✅ EstadoSucursal constructor - objeto creado:', {
      Id_estado: this.Id_estado,
      Id_sucursal: this.Id_sucursal,
      Estado: this.Estado,
      Observa: this.Observa,
      Fecha: this.Fecha,
      Hora: this.Hora,
      Nombre_sucursal: this.Nombre_sucursal
    });
    
    // ✅ Validaciones opcionales
    if (this.Id_estado === 0 && data.id_estado !== undefined && data.id_estado !== 0) {
      console.warn('⚠️ ADVERTENCIA: Id_estado no se pudo mapear. Data original:', data);
    }
    if (this.Id_sucursal === 0 && data.id_sucursal !== undefined && data.id_sucursal !== 0) {
      console.warn('⚠️ ADVERTENCIA: Id_sucursal no se pudo mapear. Data original:', data);
    }
  }

  // Validaciones
  isValid() {
    return this.Estado && this.Estado.trim() !== '' && this.Id_sucursal > 0;
  }

  // ✅ MÉTODO PARA GET - Formato completo con ID
  toApiFormat() {
    return {
      id_estado: this.Id_estado,
      id_sucursal: this.Id_sucursal,
      estado: this.Estado,
      observa: this.Observa,
      fecha: this.Fecha,
      hora: this.Hora,
      nombre_sucursal: this.Nombre_sucursal
    };
  }

  // ✅ MÉTODO PARA POST - Sin ID (el backend lo genera)
  toCreateFormat() {
    const data = {
      id_sucursal: this.Id_sucursal,
      estado: this.Estado
    };
    
    // ✅ Solo agregar campos opcionales si tienen valor
    if (this.Observa && this.Observa.trim() !== '') {
      data.observa = this.Observa;
    }
    
    if (this.Fecha && this.Fecha.trim() !== '') {
      data.fecha = this.Fecha;
    }
    
    if (this.Hora && this.Hora.trim() !== '') {
      data.hora = this.Hora;
    }
    
    if (this.Nombre_sucursal && this.Nombre_sucursal.trim() !== '') {
      data.nombre_sucursal = this.Nombre_sucursal;
    }
    
    return data;
  }

  // ✅ MÉTODO PARA DEBUG MEJORADO
  toDebug() {
    return {
      'Frontend (mayúsculas)': {
        Id_estado: this.Id_estado,
        Id_sucursal: this.Id_sucursal,
        Estado: this.Estado,
        Observa: this.Observa,
        Fecha: this.Fecha,
        Hora: this.Hora,
        Nombre_sucursal: this.Nombre_sucursal
      },
      'API Format (minúsculas)': this.toApiFormat(),
      'Create Format': this.toCreateFormat(),
      'Is Valid': this.isValid()
    };
  }
}